export const INCENTIVE_GAMES_RGI = 'incentive_games';
export const REWARD_MACHINE_WELCOME_KEY = 'reward-machine-welcome';

export const isPageRewardsMachineExitScreen = (currentRoute: string): boolean =>
    '/reward-machine-exit-screen' === currentRoute;

export const isPageRewardMachineInfo = (currentRoute: string): boolean => '/reward-machine-info' === currentRoute;
